import { render } from "./navigationViews.vue?vue&type=template&id=066fd64a&scoped=true"
import script from "./navigationViews.vue?vue&type=script&lang=js"
export * from "./navigationViews.vue?vue&type=script&lang=js"

import "./navigationViews.vue?vue&type=style&index=0&id=066fd64a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066fd64a"]])

export default __exports__